import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSpinner = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 74,
	height: 74,
	viewBox: "0 0 74 74",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M73 37C73 56.8823 56.8823 73 37 73C17.1177 73 1 56.8823 1 37C1 17.1177 17.1177 1 37 1",
		stroke: "#033174",
		strokeWidth: 2,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})
});
export default SvgSpinner;
